import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/services';
import { Router } from '@angular/router';
import { takeWhile } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss']
})
export class CallbackComponent implements OnInit {

  user = null;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router) { }

  ngOnInit() {
    this.authService.user$
      .pipe(takeWhile(res => this.user === null))
      .subscribe(user => {
        if (user) {
          this.user = user;
          if (this.user.isExternal) {
            this.router.navigate(['company']);
          } else {
            this.router.navigate(['users']);
          }
        }
      });
  }

}
